module.exports = __webpack_public_path__ + "img/about-bg.35006ebd.jpg";